// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Table,
//   Button,
//   Badge,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Input,
//   Label
// } from "reactstrap";

// const AssignTrainingsModal = ({ isOpen, toggle, server }) => {
//   const [selected, setSelected] = useState([]);

//   // dummy flashcards – replace with API
//   const flashcards = [
//     { id: 1, name: "BBQ Platter", course: "Main Course" },
//     { id: 2, name: "Beef Skewers", course: "Appetizer" },
//     { id: 3, name: "Beef Tartare", course: "Appetizer" }
//   ];

//   const toggleCard = (id) => {
//     setSelected((prev) =>
//       prev.includes(id)
//         ? prev.filter((x) => x !== id)
//         : [...prev, id]
//     );
//   };

//   if (!server) return null;

//   return (
//     <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
//       <ModalHeader toggle={toggle}>
//         Assign Trainings to {server.name}
//         <div className="text-muted small">
//           Click on flashcards to select them for training assignment
//         </div>
//       </ModalHeader>

//       <ModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
//         <Row className="g-3">
//           {flashcards.map((card) => {
//             const active = selected.includes(card.id);
//             return (
//               <Col md="6" key={card.id}>
//                 <div
//                   onClick={() => toggleCard(card.id)}
//                   className={`border rounded p-3 position-relative ${
//                     active ? "border-primary" : ""
//                   }`}
//                   style={{ cursor: "pointer" }}
//                 >
//                   <h6 className="mb-1">{card.name}</h6>
//                   <Badge color="success">{card.course}</Badge>

//                   {active && (
//                     <i
//                       className="ri-check-line text-primary position-absolute"
//                       style={{ top: 10, right: 10 }}
//                     />
//                   )}
//                 </div>
//               </Col>
//             );
//           })}
//         </Row>
//       </ModalBody>

//       <ModalFooter className="w-100 justify-content-between">
//         <span className="text-muted">{selected.length} selected</span>
//         <div>
//           <Button outline onClick={toggle}>Cancel</Button>
//           <Button color="primary" className="ms-2">
//             Assign Selected
//           </Button>
//         </div>
//       </ModalFooter>
//     </Modal>
//   );
// };

// export default AssignTrainingsModal;

import React, { useCallback, useMemo, useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const AssignTrainingsModal = ({
  isOpen,
  toggle,
  server,
  updateSingleServer
}) => {
  
  const [flashcards, setFlashcards] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState("Assigned");
  const [completionDate, setCompletionDate] = useState(null);

  const tomorrow = useMemo(() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 1);
    return date;
  }, []);

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // ✅ Fetch flashcards
  const fetchFlashcards = useCallback(() => {
    setLoading(true);

    postDataAPI({
      serviceName: "item_data",
      op: "server_coaching_outlet_items",
      server_id: server?.server_id,
      display_classcification: "Yes",
      type: "Flash",
      status: "Active",
      load: 1,
      is_show_all: true,
      course_id: "",
      flash_status: "Complete"
    })
      .then((res) => {
        if (res.status === "ok") {
          setFlashcards(res.data.server_data || []);
        }
      })
      .finally(() => setLoading(false));
  }, [server?.server_id]);

  // ✅ Init modal data
  const defaultDate = useMemo(() => {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    return date;
  }, []);
  useEffect(() => {
    if (isOpen && server) {
      fetchFlashcards();

      // Start with no cards selected; user chooses which assigned/completed cards to remove.
      // setSelected([]);
      setCompletionDate(defaultDate);

      // Pre-select already assigned cards
      // setSelected(
      //   Array.isArray(server.flash_cards)
      //     ? server.flash_cards.map(String)
      //     : []
      // );

      // Start with no cards selected; user chooses which assigned/completed cards to remove.
      setSelected([]);
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const assignedIds = useMemo(
    () => new Set(Array.isArray(server?.flash_cards) ? server.flash_cards.map(String) : []),
    [server]
  );

  const quizMap = useMemo(
    () =>
      new Map(
        Array.isArray(server?.quiz_data)
          ? server.quiz_data
              .filter((item) => assignedIds.has(String(item.flash_id)))
              .map((item) => [String(item.flash_id), item])
          : []
      ),
    [server?.quiz_data, assignedIds]
  );

  const categorizedCards = useMemo(() => {
    const groups = {
      Completed: [],
      Assigned: [],
      "Non assigned": []
    };

    flashcards.forEach((card) => {
      const id = String(card.flash_id);
      const isCompleted = quizMap.has(id);
      const isAssigned = assignedIds.has(id);

      if (isCompleted) {
        groups.Completed.push(card);
      } else if (isAssigned) {
        groups.Assigned.push(card);
      } else {
        groups["Non assigned"].push(card);
      }
    });

    return groups;
  }, [flashcards, assignedIds, quizMap]);

  const tabConfig = [
    { key: "Completed", label: "Completed" },
    { key: "Assigned", label: "Assigned" },
    { key: "Non assigned", label: "Non assigned" }
  ];

  const visibleCards = categorizedCards[activeTab] || [];

  // ✅ Toggle card
  const toggleCard = (id) => {
    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  // ✅ Assign / unassign API
  const handleAssign = () => {
    if (!selected.length) {
      alert("Please select at least one flashcard");
      return;
    }

    if (activeTab === "Non assigned" && !completionDate) {
      alert("Please select a completion date for the assigned flashcards");
      return;
    }

    setSaving(true);

    const currentAssigned = Array.isArray(server.flash_cards)
      ? server.flash_cards.map(String)
      : [];

    const flash_card_id =
      activeTab === "Non assigned"
        ? Array.from(new Set([...currentAssigned, ...selected]))
        : currentAssigned.filter((id) => !selected.includes(id));

    postDataAPI({
      serviceName: "server_data",
      op: "create_update_server_flash_cards",
      server_id: server.server_id,
      flash_card_id,
      ...(activeTab === "Non assigned" && completionDate
        ? { target_complete_date: formatLocalDate(completionDate) }
        : {}),
    })
      .then((res) => {
        if (res.status === "ok") {
          const updatedFlashCards = flash_card_id;
          const updatedQuizData = (server.quiz_data || []).filter((q) =>
            flash_card_id.includes(String(q.flash_id))
          );

          if (updateSingleServer) {
            updateSingleServer(server.server_id, {
              flash_cards: updatedFlashCards,
              quiz_data: updatedQuizData
            });
          }

          setSelected([]);
          setCompletionDate(defaultDate);
          fetchFlashcards();
        } else {
          alert(res.message || "Failed to assign flashcards");
        }
      })
      .finally(() => setSaving(false));
  };

  if (!server) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        Assign Trainings to {server.name}
        <div className="text-muted small">
          Select flashcards to assign or unassign
        </div>
      </ModalHeader>

      <ModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <Nav tabs className="mb-3">
          {tabConfig.map((tab) => (
            <NavItem key={tab.key}>
              <NavLink
                href="#"
                className={activeTab === tab.key ? "active" : ""}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab(tab.key);
                }}
              >
                {tab.label} ({categorizedCards[tab.key]?.length || 0})
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        {loading ? (
          <p className="text-center text-muted">Loading flashcards...</p>
        ) : visibleCards.length === 0 ? (
          <p className="text-center text-muted py-4">
            No flashcards in this category.
          </p>
        ) : (
          <Row className="g-3">
            {visibleCards.map((card) => {
              const id = String(card.flash_id);
              const active = selected.includes(id);

              const completionDateLabel =
                activeTab === "Completed"
                  ? quizMap.get(id)?.quiz_completed_date || ""
                  : card.completion_date || "";

              const quizItem = quizMap.get(id);
              const score = quizItem ? Number(quizItem.score || 0) : 0;
              const totalQuestions = quizItem ? Number(quizItem.total_questions || 0) : 0;
              const quizScore = quizItem ? `${score}/${totalQuestions}` : null;
              const quizPercentage = totalQuestions > 0 ? (score / totalQuestions) * 100 : 0;
              const quizStatus = quizPercentage >= 50 ? "success" : "danger";

              return (
                <Col md="6" key={id}>
                  <div
                    onClick={() => toggleCard(id)}
                    className={`border rounded p-3 position-relative ${
                      active ? "border-primary bg-light" : ""
                    }`}
                    style={{ cursor: "pointer" }}
                  >
                    <h6 className="mb-1">{card.item_name}</h6>
                    <Badge color="primary">{card.course_name}</Badge>
                    
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <div>
                        {activeTab === "Completed" && quizScore !== null && (
                          <Badge color={quizStatus} pill>
                            Score: {quizScore}
                          </Badge>
                        )}
                      </div>
                      {completionDateLabel && (
                        <Badge
                          color={activeTab === "Completed" ? "success" : "info"}
                        >
                          {activeTab === "Completed"
                            ? "Completed:"
                            : "Due:"}{" "}
                          {completionDateLabel}
                        </Badge>
                      )}
                    </div>

                    {active && (
                      <i
                        className="ri-check-line text-primary position-absolute"
                        style={{ top: 10, right: 10, fontSize: 18 }}
                      />
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </ModalBody>

      <ModalFooter className="w-100 justify-content-between">
        <div className="d-flex align-items-center gap-3">
          {activeTab === "Non assigned" && (
            <div className="d-flex align-items-center gap-2">
              <Flatpickr
                className="form-control"
                value={completionDate}
                onChange={(dates) => setCompletionDate(dates[0] || null)}
                options={{
                  dateFormat: "Y-m-d",
                  minDate: tomorrow,
                  altInput: false,
                  allowInput: true
                }}
                placeholder="Select Completion Date"
              />
            </div>
          )}
        </div>

        <div>
          <Button outline onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            className="ms-2"
            onClick={handleAssign}
            disabled={saving}
          >
            {/* {saving ? "Assigning..." : "Assign Selected"} */}
            {saving
              ? activeTab === "Non assigned"
                ? "Assigning..."
                : "Unassigning..."
              : activeTab === "Non assigned"
              ? "Assign Selected"
              : "Unassign Selected"}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default AssignTrainingsModal;
